(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campus-signup"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* This tag is compiled into the site-wide scripts.js: bail out quietly on
     pages that don't render the campus signup section. */
  var localeEl = document.getElementById('campus-locale-data');
  var form = document.getElementById('campusClaimForm');
  if (!localeEl || !form) return;

  /* ---- Locale data (Shopify's | t HTML-encodes entities; decode them) ---- */
  var rawT = JSON.parse(localeEl.textContent);
  var decodeEl = document.createElement('textarea');
  function decodeHtml(s) { decodeEl.innerHTML = s; return decodeEl.value; }
  var T = {};
  for (var k in rawT) { T[k] = typeof rawT[k] === 'string' ? decodeHtml(rawT[k]) : rawT[k]; }

  /* Placeholders use Shopify's double-brace convention; the regex is built
     from escaped parts so no literal Liquid braces appear in this file. */
  function fillPlaceholder(template, name, value) {
    return template.replace(new RegExp('\\{\\{\\s*' + name + '\\s*\\}\\}', 'g'), value);
  }
  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  /* ---- Configuration ---- */
  /* Dev override — run once in the browser console of a theme-dev preview:
       localStorage.setItem('campus_api_base', 'http://localhost:3001')
       localStorage.removeItem('campus_api_base')
     Keeps local testing out of the source. Production visitors are unaffected. */
  var apiBaseOverride = '';
  try { apiBaseOverride = localStorage.getItem('campus_api_base') || ''; } catch (e) {}
  var API_BASE = apiBaseOverride || 'https://api.enroutejewelry.com';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var PHONE_RE = /^[+\d][\d\s().-]{6,19}$/;

  var emailInput = document.getElementById('campusEmail');
  var phoneInput = document.getElementById('campusPhone');
  var termsInput = document.getElementById('campusConsentTerms');
  var emailConsentInput = document.getElementById('campusConsentEmail');
  var submitBtn = document.getElementById('campusSubmitBtn');
  var emailHint = document.getElementById('campusEmailHint');
  var phoneHint = document.getElementById('campusPhoneHint');

  /* Both consents are required to claim a code, so each checkbox gates the
     submit button. */
  function refreshSubmit() {
    submitBtn.disabled = !(
      EMAIL_RE.test(emailInput.value.trim()) &&
      termsInput.checked &&
      emailConsentInput.checked
    );
  }
  emailInput.addEventListener('input', function () {
    emailInput.classList.remove('invalid');
    emailHint.textContent = '';
    refreshSubmit();
  });
  termsInput.addEventListener('change', refreshSubmit);
  emailConsentInput.addEventListener('change', refreshSubmit);
  phoneInput.addEventListener('input', function () {
    phoneInput.classList.remove('invalid');
    phoneHint.textContent = '';
  });

  function show(stateId) {
    var states = document.querySelectorAll('.campus-state');
    for (var i = 0; i < states.length; i++) states[i].classList.remove('active');
    document.getElementById(stateId).classList.add('active');
  }

  function setLoading(loading) {
    if (loading) {
      submitBtn.classList.add('campus-btn--loading');
      submitBtn.disabled = true;
    } else {
      submitBtn.classList.remove('campus-btn--loading');
      refreshSubmit();
    }
  }

  /* A code only lives for hours, so the deadline has to carry a time of day:
     a bare date would read as "any time that day". */
  function formatDeadline(iso) {
    try {
      return new Date(iso).toLocaleString(T._locale || 'en', {
        month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit'
      });
    } catch (e) {
      return new Date(iso).toString();
    }
  }

  function renderSuccess(email, data) {
    document.getElementById('campusSuccessSchool').textContent = (data.school && data.school.name) || '';
    document.getElementById('campusSuccessEmail').textContent = email;
    var discount = fillPlaceholder(T.percent_off, 'percent', String(data.discountPercent));
    var meta = fillPlaceholder(T.success_meta, 'percent', '<strong>' + escapeHtml(discount) + '</strong>');
    meta = fillPlaceholder(meta, 'date', '<strong>' + escapeHtml(formatDeadline(data.expiresAt)) + '</strong>');
    document.getElementById('campusSuccessMeta').innerHTML = meta;
    /* Renewing is also a returning visit, but only one of the two notes
       should speak, and the renewal one carries more news. */
    var renewed = !!data.renewed;
    document.getElementById('campusRenewedNote').classList.toggle('show', renewed);
    document.getElementById('campusReturningNote').classList.toggle('show', !renewed && !!data.returning);
    show('campusStateSuccess');
  }

  function renderMiss(email) {
    var domain = '@' + (email.split('@')[1] || '');
    document.getElementById('campusMissBody').innerHTML =
      fillPlaceholder(T.miss_body, 'domain', '<strong>' + escapeHtml(domain) + '</strong>');
    show('campusStateMiss');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = emailInput.value.trim().toLowerCase();
    var phone = phoneInput.value.trim();

    if (!termsInput.checked || !emailConsentInput.checked) {
      return;
    }
    if (!EMAIL_RE.test(email)) {
      emailInput.classList.add('invalid');
      emailHint.textContent = T.invalid_email;
      return;
    }
    if (phone && !PHONE_RE.test(phone)) {
      phoneInput.classList.add('invalid');
      phoneHint.textContent = T.invalid_phone;
      return;
    }

    var payload = { email: email, consent: true };
    if (phone) payload.phone = phone;
    var params = new URLSearchParams(window.location.search);
    var utmKeys = ['utm_source', 'utm_medium', 'utm_campaign'];
    for (var i = 0; i < utmKeys.length; i++) {
      var v = params.get(utmKeys[i]);
      if (v) payload[utmKeys[i]] = v;
    }

    setLoading(true);
    fetch(API_BASE + '/campus_signup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (body) {
        setLoading(false);
        var data = (body && body.data) || {};
        if (data.success && data.matched && data.used) {
          show('campusStateUsed');
        } else if (data.success && data.matched) {
          renderSuccess(email, data);
        } else if (data.success) {
          renderMiss(email);
        } else {
          show('campusStateError');
        }
      })
      .catch(function () {
        setLoading(false);
        show('campusStateError');
      });
  });

  var resets = document.querySelectorAll('.campus-reset');
  for (var r = 0; r < resets.length; r++) {
    resets[r].addEventListener('click', function () {
      show('campusStateForm');
      emailInput.focus();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return-request"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* ---- Load locale data ---- */
  var rawT = JSON.parse(document.getElementById('return-locale-data').textContent);
  /* Shopify's | t filter HTML-encodes apostrophes (&#39;) and other entities.
     Decode them so JS strings display correctly via textContent. */
  var decodeEl = document.createElement('textarea');
  function decodeHtml(s) { decodeEl.innerHTML = s; return decodeEl.value; }
  var T = {};
  for (var k in rawT) { T[k] = typeof rawT[k] === 'string' ? decodeHtml(rawT[k]) : rawT[k]; }

  /* ---- Load reason icon asset URLs ---- */
  var REASON_ICONS = {};
  var assetEl = document.getElementById('return-asset-data');
  if (assetEl) { try { REASON_ICONS = JSON.parse(assetEl.textContent) || {}; } catch (e) {} }

  /* ---- Configuration ---- */
  /* Dev override — run once in the browser console of a theme-dev preview:
       localStorage.setItem('return_api_base', 'http://localhost:3001')  // point at a local dev server
       localStorage.removeItem('return_api_base')                        // back to production
     Keeps local testing out of the source, so a localhost API_BASE can
     never be committed by accident. Production visitors are unaffected. */
  var apiBaseOverride = '';
  try { apiBaseOverride = localStorage.getItem('return_api_base') || ''; } catch (e) {}
  const API_BASE = apiBaseOverride || 'https://api.enroutejewelry.com';

  const REASON_OPTIONS = [
    { value: '', label: T.please_select },
    { value: 'ARRIVED_TOO_LATE', label: T.arrived_too_late },
    { value: 'SIZE_TOO_BIG_SMALL', label: T.size_too_big_small },
    { value: 'DOES_NOT_SUIT_ME', label: T.doesnt_suit_me },
    { value: 'POOR_QUALITY_DEFECT', label: T.poor_quality_defect },
    { value: 'OTHERS', label: T.others },
  ];

  /* Order-level solution options (one chosen per return submission) */
  const SOLUTION_OPTIONS = [
    { value: '', label: T.please_select },
    { value: 'REFUND_STORE_CREDIT', label: T.solution_store_credit_nonus },
    { value: 'EXCHANGE', label: T.solution_exchange },
    { value: 'REPLACE', label: T.solution_replace },
    { value: 'REFUND_ORIGINAL', label: T.solution_refund_original },
  ];

  /**
   * Reason → solutions the customer may choose for that reason (per ops spec):
   *   - store credit / refund original: available for every reason
   *   - exchange: every reason except "arrived too late"
   *   - replace: only damaged/defect and other reasons
   */
  const REASON_SOLUTIONS = {
    ARRIVED_TOO_LATE:    ['REFUND_STORE_CREDIT', 'REFUND_ORIGINAL'],
    SIZE_TOO_BIG_SMALL:  ['REFUND_STORE_CREDIT', 'REFUND_ORIGINAL', 'EXCHANGE'],
    DOES_NOT_SUIT_ME:    ['REFUND_STORE_CREDIT', 'REFUND_ORIGINAL', 'EXCHANGE'],
    POOR_QUALITY_DEFECT: ['REFUND_STORE_CREDIT', 'REFUND_ORIGINAL', 'EXCHANGE', 'REPLACE'],
    OTHERS:              ['REFUND_STORE_CREDIT', 'REFUND_ORIGINAL', 'EXCHANGE', 'REPLACE'],
  };

  /* Solutions allowed by the chosen reasons = intersection across items
     (an order-level solution must be valid for every selected reason).
     An unknown/empty reason adds no restriction; returns null when unrestricted. */
  function reasonAllowedSolutions(reasons) {
    var allowed = null;
    reasons.forEach(function(r) {
      var set = REASON_SOLUTIONS[r];
      if (!set) return;
      allowed = (allowed === null)
        ? set.slice()
        : allowed.filter(function(v) { return set.indexOf(v) !== -1; });
    });
    return allowed;
  }

  /* EU member-state ISO 3166-1 alpha-2 codes (EU-27). Used to branch the
     return flow: EU orders may start a return before the order is fulfilled. */
  const EU_COUNTRY_CODES = {
    AT: 1, BE: 1, BG: 1, HR: 1, CY: 1, CZ: 1, DK: 1, EE: 1, FI: 1, FR: 1,
    DE: 1, GR: 1, HU: 1, IE: 1, IT: 1, LV: 1, LT: 1, LU: 1, MT: 1, NL: 1,
    PL: 1, PT: 1, RO: 1, SK: 1, SI: 1, ES: 1, SE: 1,
  };

  /* True when the given ISO country code is an EU-27 member state. */
  function countryIsEU(code) {
    return !!(code && EU_COUNTRY_CODES[code]);
  }

  /* True when the current order ships to an EU country. */
  function isEUOrder() {
    return !!(state.orderData && countryIsEU(state.orderData.shippingCountryCode));
  }

  /* True when the current order is EU and still unfulfilled (no items shipped).
     The backend must signal this with order.unfulfilled, derived from the real
     fulfillment status (e.g. displayFulfillmentStatus === 'UNFULFILLED').
     NOTE: orderNotShipped is a separate flag and is observed to be false even
     for unfulfilled orders, so it must NOT be used here.
     In this mode the flow skips the fulfillment gate, limits the return reason
     to "Others" (description optional), and offers a reduced solution set. */
  function isEUUnfulfilled() {
    return isEUOrder() && !!(state.orderData && state.orderData.unfulfilled);
  }

  /* True when the order was created within the last `days` days.
     Relies on order.createdAt (ISO 8601) from the API; false if missing/unparsable.
     Timezone-safe: both sides compare absolute epoch ms. */
  function orderWithinDays(days) {
    var created = state.orderData && state.orderData.createdAt;
    if (!created) return false;
    var createdMs = Date.parse(created);
    if (isNaN(createdMs)) return false;
    var ageMs = Date.now() - createdMs;
    return ageMs >= 0 && ageMs <= days * 24 * 60 * 60 * 1000;
  }

  /* EU orders within 15 days of creation (and fulfilled) make the return reason
     optional. Damaged/defective still requires photo proof (see proofRequiredFor).
     Unfulfilled EU orders keep their own "Others"-only mode, so exclude them. */
  function isEUReasonOptional() {
    return isEUOrder() && !isEUUnfulfilled() && orderWithinDays(15);
  }

  /* Whether the return description is mandatory for a given reason.
     EU-unfulfilled and EU-within-15-days returns keep it optional. */
  function descriptionRequiredFor(reason) {
    if (isEUUnfulfilled() || isEUReasonOptional()) return false;
    return reason === 'POOR_QUALITY_DEFECT' || reason === 'OTHERS';
  }

  /* Whether photo/video proof is mandatory for a given reason. */
  function proofRequiredFor(reason) {
    if (isEUUnfulfilled()) return false;
    return reason === 'POOR_QUALITY_DEFECT';
  }

  /**
   * Solutions allowed for the current selection. Two stacked filters:
   *   1. 45-day refund window: items past it come back with exchangeOnly=true,
   *      which restricts the whole submission to EXCHANGE / REPLACE.
   *   2. Reason gating (per ops spec, see REASON_SOLUTIONS) — e.g. "arrived too
   *      late" can't exchange; "replace" only for damaged/defect or other reasons.
   * EU-unfulfilled orders bypass both and get a fixed set of three solutions.
   */
  function allowedSolutionOptions(items, reasons) {
    /* EU + unfulfilled: store credit, original payment, or exchange only. */
    if (isEUUnfulfilled()) {
      var euOptions = SOLUTION_OPTIONS.filter(function(o) {
        return o.value === '' || o.value === 'REFUND_STORE_CREDIT'
          || o.value === 'REFUND_ORIGINAL' || o.value === 'EXCHANGE';
      });
      return { exchangeOnly: false, options: euOptions };
    }
    var exchangeOnly = items.some(function(i) { return !!(i && i.exchangeOnly); });
    var options = SOLUTION_OPTIONS;
    if (exchangeOnly) {
      options = options.filter(function(o) {
        return o.value === '' || o.value === 'EXCHANGE' || o.value === 'REPLACE';
      });
    }
    var reasonAllowed = reasons ? reasonAllowedSolutions(reasons) : null;
    if (reasonAllowed) {
      options = options.filter(function(o) {
        return o.value === '' || reasonAllowed.indexOf(o.value) !== -1;
      });
    }
    return { exchangeOnly: exchangeOnly, options: options };
  }

  /**
   * Resolve solution label. Two variants:
   *   - US shipping country: picks the US-specific copy (includes $6.89 shipping fee text)
   *   - non-US shipping country: appends bonus gift card copy
   *     (REFUND_STORE_CREDIT and EXCHANGE both: fixed $10 USD bonus gift card)
   */
  function getSolutionLabel(value) {
    /* EU-unfulfilled: plain labels, no US shipping-fee text and no bonus copy. */
    if (isEUUnfulfilled()) {
      var oEu = SOLUTION_OPTIONS.find(function(x) { return x.value === value; });
      return oEu ? oEu.label : value;
    }
    var isUS = state.orderData && state.orderData.shippingCountryCode === 'US';
    if (isUS) {
      if (value === 'REFUND_STORE_CREDIT') return T.solution_store_credit_us;
      if (value === 'REFUND_ORIGINAL') return T.solution_refund_original_us;
      var oUs = SOLUTION_OPTIONS.find(function(x) { return x.value === value; });
      return oUs ? oUs.label : value;
    }
    /* non-US: append bonus copy where applicable (fixed $10 for both), unless
       the bonus is withheld because this order already had a return in 7 days —
       then fall through to the plain SOLUTION_OPTIONS label (no bonus mention). */
    var bonusOk = !(state.orderData && state.orderData.bonusSuppressed);
    if (bonusOk && value === 'REFUND_STORE_CREDIT') return T.solution_store_credit_bonus;
    if (bonusOk && value === 'EXCHANGE') return T.solution_exchange_bonus;
    var o = SOLUTION_OPTIONS.find(function(x) { return x.value === value; });
    return o ? o.label : value;
  }

  /**
   * Format a money amount with the ISO currency code prefix (e.g. "USD 55.20", "SAR 207.00").
   * Used in the non-US store-credit what-to-expect copy, which shows the USD gift-card value
   * alongside the customer's original payment currency. Fixed en-US locale keeps the
   * "<code> <amount>" layout stable regardless of the shopper's browser locale.
   */
  function formatMoneyCode(amount, currency) {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'code',
      }).format(amount);
    } catch (e) {
      return currency + ' ' + parseFloat(amount || 0).toFixed(2);
    }
  }

  /* Escape a user-supplied string for safe insertion into HTML (email is typed by the customer). */
  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* Turn the store domain into a clickable link. Only matches when preceded by start/space/paren,
     so it never touches the domain inside a customer's email (e.g. love@enroutejewelry.com). */
  function linkifyStoreDomain(text) {
    return text.replace(
      /(^|[\s(])enroutejewelry\.com/g,
      '$1<a href="{{ routes.root_url }}" target="_blank" rel="noopener">enroutejewelry.com</a>',
    );
  }

  /* Non-returnable reason code → localized label mapping */
  const NR_REASON_LABELS = {
    'NOT_FULFILLED': T.nr_not_fulfilled,
    'RETURN_WINDOW_EXPIRED': T.nr_return_window_expired,
    'GIFT_CARD': T.nr_gift_card,
    'CUSTOMIZED': T.nr_customized,
    'ALREADY_SUBMITTED': T.nr_already_submitted,
  };

  const MAX_IMAGES_PER_ITEM = 3;
  const MAX_IMAGE_WIDTH = 1200;
  const MAX_IMAGE_SIZE_MB = 2;

  /* Line-item thumbnails are rendered in a 64px box at most (56px in the review
     step), so 128px covers a 2x screen. One width for every thumbnail means the
     same product resolves to the same URL across steps and is fetched once. */
  const THUMB_WIDTH = 128;

  /* Ask the Shopify CDN for a resized thumbnail instead of the full-size original.
     item.imageUrl comes from the returns API, so leave anything that isn't a
     Shopify CDN URL — or that already carries a width — untouched. */
  function thumbUrl(url) {
    if (!url) return '';
    if (url.indexOf('/cdn/') === -1 && url.indexOf('cdn.shopify.com') === -1) return url;
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + THUMB_WIDTH;
  }

  /* ---- Helper: format price to 2 decimal places ---- */
  function formatPrice(p) {
    return parseFloat(p || 0).toFixed(2);
  }

  /**
   * Format a money amount in the customer's checkout currency.
   * Uses Intl.NumberFormat when available for proper symbol + locale formatting.
   */
  function formatPresentmentAmount(amount, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol',
      }).format(amount);
    } catch (e) {
      return currency + ' ' + parseFloat(amount || 0).toFixed(2);
    }
  }

  /**
   * Render an item's unit price in the currency the customer paid at checkout.
   * When the customer paid less than the listed price (discount code / order
   * discount), shows the original struck through next to the paid price.
   * Falls back to original-price-only when the API doesn't send paid fields.
   */
  function renderMoney(item) {
    var currency = item.presentmentCurrencyCode || item.currencyCode || 'USD';
    var original = parseFloat(item.presentmentPrice || item.price || 0);
    var paid = parseFloat(item.paidPresentmentPrice || item.presentmentPrice || item.price || 0);
    if (paid < original) {
      return '<span class="return-price-original">' + formatPresentmentAmount(original, currency) + '</span>' +
        formatPresentmentAmount(paid, currency);
    }
    return formatPresentmentAmount(original, currency);
  }

  /**
   * Parse variantTitle like "Gold: Yellow Gold / Size: 6"
   * Returns { swatchHtml, textParts } where swatchHtml uses the project's
   * existing hvg-option-color-{name} CSS classes from customhvg-product.css.
   */
  var KNOWN_COLOR_CLASSES = ['gold', 'silver', 'rose-gold', 'pink', 'green', 'yellow', 'red', 'black', 'blue'];
  /* Map common color values to the CSS class suffix */
  var COLOR_CLASS_MAP = {
    'gold': 'gold', 'yellow gold': 'gold', 'yellow': 'yellow',
    'rose gold': 'rose-gold', 'rose': 'rose-gold',
    'silver': 'silver', 'sterling silver': 'silver',
    'pink': 'pink', 'red': 'red', 'black': 'black', 'blue': 'blue',
    'green': 'green', 'white': 'silver', 'white gold': 'silver',
    'platinum': 'silver', 'gunmetal': 'black',
  };

  function parseVariantDisplay(variantTitle) {
    if (!variantTitle) return { swatchHtml: '', textParts: '' };
    var parts = variantTitle.split(' / ');
    var swatchHtml = '';
    var textParts = [];

    parts.forEach(function(part) {
      var colonIdx = part.indexOf(':');
      var optName = colonIdx >= 0 ? part.substring(0, colonIdx).trim().toLowerCase() : '';
      var optValue = colonIdx >= 0 ? part.substring(colonIdx + 1).trim() : part.trim();
      var isColorOpt = (optName === 'color' || optName === 'gold' || optName === 'colour');

      if (!isColorOpt) {
        var valLower = optValue.toLowerCase();
        if (COLOR_CLASS_MAP[valLower]) isColorOpt = true;
      }

      if (isColorOpt && !swatchHtml) {
        var cls = COLOR_CLASS_MAP[optValue.toLowerCase()] || COLOR_CLASS_MAP[optName] || null;
        if (cls) {
          swatchHtml = '<span class="return-color-swatch hvg-option-color-' + cls + '"></span>';
        } else {
          textParts.push(part);
        }
      } else {
        textParts.push(part);
      }
    });

    return { swatchHtml: swatchHtml, textParts: textParts.join(' / ') };
  }

  /* "Part of set: X" hint for set-component rows the backend split out of a
     bundle line item (their price is the set price allocated by weight). */
  function setHintHtml(item) {
    if (!item || !item.setTitle) return '';
    var fallback = 'Part of set: {' + '{ name }' + '}'; /* split so Liquid doesn't parse it */
    var label = (T.set_component_hint || fallback).replace(/\{\{\s*name\s*\}\}/g, item.setTitle);
    return '<div class="return-product-set-hint">' + label + '</div>';
  }

  /* ---- State ---- */
  const state = {
    orderData: null,
    /* Order-level solution (chosen once for the whole return; per-item solution is no longer supported) */
    orderSolution: '',
    selectedItems: {},
    /* uploadedImages[idx] = [{ base64, contentType, fileName, feishuImageKey }] — stored in memory until submit */
    uploadedImages: {},
    /* orders fetched by loadLoggedInOrders (for pendingReturn check) */
    ordersMap: {},
  };

  /* ---- Helper: all selected items are damaged/defective — no return shipment needed,
          so US refund/credit copy switches from "delivered" to "approved" ---- */
  function allSelectedDefective() {
    var keys = Object.keys(state.selectedItems);
    return keys.length > 0 && keys.every(function(idx) {
      return state.selectedItems[idx].reason === 'POOR_QUALITY_DEFECT';
    });
  }

  /* ---- Helper: reset success page to default hidden state ---- */
  function resetSuccessPage() {
    document.getElementById('returnSuccessTitle').textContent = T.success_title;
    document.getElementById('returnSuccessMessage').textContent = '';
    document.getElementById('returnSuccessHowTo').style.display = 'none';
    document.getElementById('returnSuccessFooter').style.display = 'none';
    document.getElementById('returnSuccessFollowup').style.display = 'none';
  }

  /* ---- Helper: show error ---- */
  function showError(id, msg, errorCode) {
    var el = document.getElementById(id);
    var localizedMsg = (errorCode && T['error_' + errorCode]) ? T['error_' + errorCode] : msg;
    if (el) el.textContent = localizedMsg;
    /* Show help text when entry error occurs */
    if (id === 'returnEntryError') {
      var helpEl = document.getElementById('returnHelpText');
      if (helpEl) helpEl.style.display = msg ? 'block' : 'none';
      /* Hide not-shipped notice when showing other errors */
      var notShippedEl = document.getElementById('returnNotShippedNotice');
      if (notShippedEl) notShippedEl.style.display = 'none';
    }
  }

  /* ---- Canvas image compression ---- */
  function compressImage(file) {
    return new Promise(function(resolve, reject) {
      var reader = new FileReader();
      reader.onload = function(e) {
        var img = new Image();
        img.onload = function() {
          var canvas = document.createElement('canvas');
          var w = img.width;
          var h = img.height;

          /* Scale down if wider than MAX_IMAGE_WIDTH */
          if (w > MAX_IMAGE_WIDTH) {
            h = Math.round(h * MAX_IMAGE_WIDTH / w);
            w = MAX_IMAGE_WIDTH;
          }
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);

          /* Try decreasing quality until ≤ MAX_IMAGE_SIZE_MB */
          var quality = 0.85;
          var dataUrl;
          var contentType = 'image/jpeg';
          for (var q = quality; q >= 0.3; q -= 0.1) {
            dataUrl = canvas.toDataURL('image/jpeg', q);
            /* rough size check: base64 length * 3/4 */
            var approxBytes = (dataUrl.length - dataUrl.indexOf(',') - 1) * 3 / 4;
            if (approxBytes <= MAX_IMAGE_SIZE_MB * 1024 * 1024) break;
          }

          /* Extract pure base64 (strip data:image/jpeg;base64, prefix) */
          var base64 = dataUrl.split(',')[1];
          var finalBytes = (base64.length * 3) / 4;
          if (finalBytes > 5 * 1024 * 1024) {
            reject(new Error(T.image_too_large));
            return;
          }
          resolve({ base64: base64, contentType: contentType, fileName: file.name });
        };
        img.onerror = function() { reject(new Error('Failed to load image')); };
        img.src = e.target.result;
      };
      reader.onerror = function() { reject(new Error('Failed to read file')); };
      reader.readAsDataURL(file);
    });
  }

  /* ---- Load orders for logged-in users ---- */
  (function loadLoggedInOrders() {
    var emailInput = document.getElementById('returnCustomerEmail');
    var customerIdInput = document.getElementById('returnCustomerId');
    if (!emailInput || !customerIdInput) return;

    var select = document.getElementById('returnOrderSelect');
    var email = emailInput.value;
    var customerId = customerIdInput.value;

    fetch(API_BASE + '/query_orders', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, customerId: customerId }),
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (!data.success || !data.orders || data.orders.length === 0) {
        select.innerHTML = '<option value="">' + T.no_returnable_orders + '</option>';
        return;
      }
      select.innerHTML = '<option value="">' + T.choose_order + '</option>';
      data.orders.forEach(function(order) {
        var opt = document.createElement('option');
        var name = order.name || '';
        opt.value = name.replace('#', '');
        var date = (order.createdAt || '').split('T')[0];
        var label = name + ' - ' + date + ' - ' + (order.fulfillmentStatus || '');
        if (order.pendingReturn) label += ' ' + T.pending_review_label;
        opt.textContent = label;
        select.appendChild(opt);
        /* Save order metadata for pendingReturn check */
        state.ordersMap[opt.value] = order;
      });
    })
    .catch(function(err) {
      console.error('Failed to load orders:', err);
      select.innerHTML = '<option value="">' + T.failed_to_load + '</option>';
    });
  })();

  /* ---- Render Step 2: order-level solution dropdown ----
   * Step 1 already collected per-item reason / description / images.
   * Here we show:
   *   - the list of selected items (read-only summary)
   *   - one dropdown for the order-level solution
   *   - inline exchange-info form when EXCHANGE is picked AND only 1 item is being returned
   *     (multi-item exchange info goes to Step 2.5)
   */
  function renderStep2() {
    var data = state.orderData;
    var container = document.getElementById('returnStep2Items');
    var html = '';

    var selectedKeys = Object.keys(state.selectedItems);

    /* Compact item summary (no editing, just confirmation) */
    selectedKeys.forEach(function(idx) {
      var item = data.returnableItems[idx];
      var sel = state.selectedItems[idx];
      var imgSrc = thumbUrl(item.imageUrl);

      html += '<div class="return-product-card selected" data-idx="' + idx + '">';
      html += '<div class="return-product-row">';
      if (imgSrc) html += '<div class="return-product-img"><img src="' + imgSrc + '" alt=""></div>';
      var vd2 = parseVariantDisplay(item.variantTitle);
      html += '<div class="return-product-info"><div class="return-product-name">' + item.title + '</div>';
      if (vd2.textParts) html += '<div class="return-product-variant">' + vd2.textParts + '</div>';
      if (vd2.swatchHtml) html += '<div class="return-product-variant">' + vd2.swatchHtml + '</div>';
      html += setHintHtml(item);
      html += '<div class="return-product-variant">' + T.return_quantity + ': ' + (sel.quantity || 1) + '</div>';
      html += '</div>';
      html += '<div class="return-product-price">' + renderMoney(item) + '</div>';
      html += '</div>';
      html += '</div>';
    });

    /* Order-level solution dropdown — refund options hidden when any
       selected item is past the 45-day refund window */
    var solutionAvail = allowedSolutionOptions(
      selectedKeys.map(function(idx) { return data.returnableItems[idx]; }),
      selectedKeys.map(function(idx) { return state.selectedItems[idx].reason; }),
    );
    var solutionAllowed = solutionAvail.options.some(function(o) { return o.value === state.orderSolution; });
    if (state.orderSolution && !solutionAllowed) {
      state.orderSolution = '';
    }
    html += '<div class="return-reason-group" style="margin-top:24px"><label>' + T.return_solution + ' <span class="return-req is-required">' + T.required + '</span></label>';
    html += '<select onchange="returnApp.onOrderSolutionChange(this)" id="returnOrderSolution">';
    solutionAvail.options.forEach(function(o) {
      var selected = (state.orderSolution === o.value) ? ' selected' : '';
      html += '<option value="' + o.value + '"' + selected + '>' + getSolutionLabel(o.value) + '</option>';
    });
    html += '</select>';
    if (solutionAvail.exchangeOnly) {
      html += '<div class="return-exchange-only-hint">' + T.solution_exchange_only_hint + '</div>';
    }
    html += '</div>';

    /* Inline exchange-info form: only when EXCHANGE selected AND exactly 1 item */
    var showInline = (state.orderSolution === 'EXCHANGE' && selectedKeys.length === 1);
    html += '<div id="returnExchangeInline" style="display:' + (showInline ? 'block' : 'none') + ';margin-top:16px">';
    if (selectedKeys.length === 1) {
      var soloIdx = selectedKeys[0];
      var soloSel = state.selectedItems[soloIdx];
      html += buildExchangeFieldsHtml(soloIdx, soloSel);
    }
    html += '</div>';

    container.innerHTML = html;
    if (selectedKeys.length === 1) updateExchangePickedLabel(selectedKeys[0]);
  }

  /* ---- Helper: per-item exchange picker HTML (reused in Step 2 inline + Step 2.5) ----
   * Renders a <product-picker> Web Component instead of free-text inputs. The
   * component emits enroute:product-picked / enroute:product-enrolled, which the
   * document-level listeners below write back into state.selectedItems[idx].
   * data-prefill-handle (from the source item, when the backend provides it)
   * opens straight into "exchange for a different variant of the same product".
   */
  function buildExchangeFieldsHtml(idx, sel) {
    var handle = sel.exchangeSourceHandle || '';
    var html = '';
    html += '<div class="return-reason-group return-exchange-picker">';
    html += '<label>' + T.exchange_pick_label + ' <span class="return-req is-required">' + T.required + '</span></label>';
    html += '<product-picker data-scenario="exchange" data-context-idx="' + idx + '"' + (handle ? ' data-prefill-handle="' + escapeHtml(handle) + '"' : '') + '></product-picker>';
    html += '<div class="return-exchange-picked" id="returnExchangePicked' + idx + '" style="display:none"></div>';
    html += '</div>';
    return html;
  }

  /* Reflect the persisted pick (survives step navigation even though the picker
   * UI itself re-renders fresh) as a short "Currently selected: …" line. */
  function updateExchangePickedLabel(idx) {
    var el = document.getElementById('returnExchangePicked' + idx);
    if (!el) return;
    var sel = state.selectedItems[idx];
    if (sel && sel.exchangeVariantId) {
      var parts = [sel.exchangeProductTitle, sel.exchangeVariantTitle].filter(Boolean).join(' — ');
      el.textContent = T.exchange_current + ': ' + parts;
      el.style.display = 'block';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  /* ---- Render Step 2.5: per-item exchange info for multi-item exchange returns ---- */
  function renderStep2_5() {
    var data = state.orderData;
    var container = document.getElementById('returnStep2_5Items');
    var html = '';

    Object.keys(state.selectedItems).forEach(function(idx) {
      var item = data.returnableItems[idx];
      var sel = state.selectedItems[idx];
      var imgSrc = thumbUrl(item.imageUrl);

      html += '<div class="return-product-card selected" data-idx="' + idx + '">';
      html += '<div class="return-product-row">';
      if (imgSrc) html += '<div class="return-product-img"><img src="' + imgSrc + '" alt=""></div>';
      var vd = parseVariantDisplay(item.variantTitle);
      html += '<div class="return-product-info"><div class="return-product-name">' + item.title + '</div>';
      if (vd.textParts) html += '<div class="return-product-variant">' + vd.textParts + '</div>';
      if (vd.swatchHtml) html += '<div class="return-product-variant">' + vd.swatchHtml + '</div>';
      html += setHintHtml(item);
      html += '</div>';
      html += '<div class="return-product-price">' + renderMoney(item) + '</div>';
      html += '</div>';

      html += '<div class="return-details" style="display:block">';
      html += buildExchangeFieldsHtml(idx, sel);
      html += '</div>';
      html += '</div>';
    });

    container.innerHTML = html;
    Object.keys(state.selectedItems).forEach(updateExchangePickedLabel);
  }

  /* ---- Order-level solution change ----
   * Triggered when the customer picks a value in the single dropdown on Step 2.
   * Toggles the inline exchange-info block when EXCHANGE is selected
   * AND only one item is being returned. With multiple items, exchange info
   * is collected in Step 2.5 instead.
   */
  function onOrderSolutionChange(select) {
    var solution = select.value;
    state.orderSolution = solution;

    var selectedCount = Object.keys(state.selectedItems).length;
    var inline = document.getElementById('returnExchangeInline');
    if (inline) {
      inline.style.display = (solution === 'EXCHANGE' && selectedCount === 1) ? 'block' : 'none';
    }
  }

  /* ---- Navigation ----
   * Step ids: 0 (entry) | 1 (pick items + reason) | 2 (order-level solution) | '2_5' (multi-item exchange info) | 3 (review) | 4 (success)
   */
  function goTo(step) {
    /* Validation before advancing to Step 2: at least 1 item, every item has reason + reason-specific required fields. */
    if (step === 2) {
      var selectedKeys1 = Object.keys(state.selectedItems);
      if (selectedKeys1.length === 0) {
        showError('returnStep1Error', T.please_select_item);
        return;
      }
      for (var k1 = 0; k1 < selectedKeys1.length; k1++) {
        var idx1 = selectedKeys1[k1];
        var sel1 = state.selectedItems[idx1];

        /* Sync per-item reason / description from DOM */
        var reasonHidden1 = document.getElementById('returnReason' + idx1);
        if (reasonHidden1) sel1.reason = reasonHidden1.value;
        var descInput1 = document.getElementById('returnDesc' + idx1);
        if (descInput1) sel1.description = descInput1.value;

        /* Reason is required except in the EU-within-15-days mode (reason optional). */
        if (!sel1.reason) {
          if (!isEUReasonOptional()) {
            showError('returnStep1Error', T.reason_required);
            return;
          }
          continue; /* no reason chosen and it's optional — nothing else to check */
        }
        /* Description required for defect/others except where a lenient EU mode relaxes it. */
        if (descriptionRequiredFor(sel1.reason) && (!sel1.description || !sel1.description.trim())) {
          showError('returnStep1Error', sel1.reason === 'OTHERS' ? T.others_description_required : T.description_required);
          return;
        }
        /* Proof still required for damaged/defective (incl. the EU-within-15-days mode). */
        if (proofRequiredFor(sel1.reason)) {
          var imgCount1 = (state.uploadedImages[idx1] || []).filter(function(x) { return x !== null; }).length;
          if (imgCount1 === 0) {
            showError('returnStep1Error', T.proof_required);
            return;
          }
        }
      }
      renderStep2();
    }

    /* Step 2.5: pre-condition (set up by caller) is EXCHANGE + multi-item; we just render. */
    if (step === '2_5') {
      renderStep2_5();
    }

    /* Validation before advancing to Step 3 (review). Solution chosen, and if EXCHANGE then all items must have exchangeProductName. */
    if (step === 3) {
      /* Sync order-level solution from DOM (may not exist if jumping from 2.5) */
      var solSelect = document.getElementById('returnOrderSolution');
      if (solSelect) state.orderSolution = solSelect.value;

      if (!state.orderSolution) {
        showError('returnStep2Error', T.validation_fill_required);
        return;
      }

      var selectedKeys3 = Object.keys(state.selectedItems);

      /* EXCHANGE requires a variant picked in the <product-picker> on every item.
       * The picker writes exchangeVariantId (+ authoritative title/sku/price) into
       * state via the enroute:product-picked listener, so there's no DOM to sync. */
      if (state.orderSolution === 'EXCHANGE') {
        for (var k4 = 0; k4 < selectedKeys3.length; k4++) {
          var idx4 = selectedKeys3[k4];
          var sel4 = state.selectedItems[idx4];
          if (!sel4.exchangeVariantId) {
            var errTarget = (selectedKeys3.length > 1) ? 'returnStep2_5Error' : 'returnStep2Error';
            showError(errTarget, T.exchange_required);
            return;
          }
        }
      }
    }

    document.querySelectorAll('.return-step').forEach(function(s) { s.classList.remove('active'); });
    document.getElementById('returnStep' + step).classList.add('active');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.querySelectorAll('.return-error').forEach(function(e) { e.textContent = ''; });

    if (step === 3) buildReview();
  }

  /* ---- Step 2 "Next" handler: decide whether to jump to Step 2.5 or straight to Step 3.
   *      Multi-item EXCHANGE goes through 2.5; everything else goes straight to review.
   */
  function nextFromStep2() {
    var solSelect = document.getElementById('returnOrderSolution');
    if (solSelect) state.orderSolution = solSelect.value;

    if (!state.orderSolution) {
      showError('returnStep2Error', T.validation_fill_required);
      return;
    }

    /* Guard: exchange-only items can't go through a refund solution
       (the dropdown already hides them; this catches stale state) */
    var avail = allowedSolutionOptions(
      Object.keys(state.selectedItems).map(function(idx) {
        return state.orderData.returnableItems[idx];
      }),
      Object.keys(state.selectedItems).map(function(idx) {
        return state.selectedItems[idx].reason;
      }),
    );
    if (!avail.options.some(function(o) { return o.value === state.orderSolution; })) {
      state.orderSolution = '';
      renderStep2();
      showError('returnStep2Error', T.solution_exchange_only_hint);
      return;
    }

    var selectedCount = Object.keys(state.selectedItems).length;
    if (state.orderSolution === 'EXCHANGE' && selectedCount > 1) {
      goTo('2_5');
    } else {
      goTo(3);
    }
  }

  /* ---- Find Order (calls real API) ---- */
  function findOrder() {
    var btn = document.getElementById('returnEntryBtn');
    btn.classList.add('return-btn-loading');
    btn.disabled = true;
    /* Clear previous notices */
    var notShippedEl = document.getElementById('returnNotShippedNotice');
    if (notShippedEl) notShippedEl.style.display = 'none';

    var email, orderName;
    var emailInput = document.getElementById('returnCustomerEmail');
    if (emailInput) {
      /* Logged-in user: get from hidden input + dropdown */
      email = emailInput.value;
      var selectEl = document.getElementById('returnOrderSelect');
      orderName = selectEl ? selectEl.value : '';
    } else {
      /* Guest user: get from form inputs */
      email = (document.getElementById('returnEmail') || {}).value || '';
      orderName = (document.getElementById('returnOrderNumber') || {}).value || '';
    }

    if (!email || !orderName) {
      btn.classList.remove('return-btn-loading');
      btn.disabled = false;
      showError('returnEntryError', 'Please enter both email and order number.', 'missing_email_or_order');
      return;
    }

    /* Item-level pending check is now handled by query_returnable_items.
       Always call the API to get accurate per-item status. */

    fetch(API_BASE + '/query_returnable_items', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      /* supportsSetComponents: this frontend renders set-component rows, so
         the backend may split sets. Legacy pages omit it and keep whole sets.
         locale: lets the backend swap product titles for their translations
         (display only — CS records keep default-language names). */
      body: JSON.stringify({
        email: email,
        orderName: orderName,
        supportsSetComponents: true,
        /* Liquid is never rendered inside this compiled JS block, so the
           locale comes from the return-locale-data JSON block instead */
        locale: rawT._locale || 'en',
      }),
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      btn.classList.remove('return-btn-loading');
      btn.disabled = false;

      if (!data.success) {
        showError('returnEntryError', data.error || 'Order not found.', data.errorCode);
        return;
      }

      /* Backend detected a pending return for this order */
      if (data.pendingReturn) {
        resetSuccessPage();
        document.getElementById('returnSuccessTitle').textContent = T.pending_review_title;
        document.getElementById('returnSuccessMessage').textContent = T.pending_review_message;
        goTo(4);
        return;
      }

      /* Order has not shipped yet — show pre-rendered notice, don't advance.
         EU orders skip this gate: they may start a return before fulfillment. */
      if (data.order && data.order.orderNotShipped && !countryIsEU(data.order.shippingCountryCode)) {
        /* Clear any previous error/help text */
        var errEl = document.getElementById('returnEntryError');
        if (errEl) errEl.textContent = '';
        var helpEl = document.getElementById('returnHelpText');
        if (helpEl) helpEl.style.display = 'none';
        var notShippedEl = document.getElementById('returnNotShippedNotice');
        if (notShippedEl) notShippedEl.style.display = 'block';
        return;
      }

      state.orderData = data.order;
      state.orderSolution = '';
      state.selectedItems = {};
      state.uploadedImages = {};

      /* Determine allExpired — show dedicated message and don't advance */
      var allExpired = !data.order.returnableItems || data.order.returnableItems.length === 0;
      state.orderData.allExpired = allExpired;
      if (allExpired && data.order.nonReturnableItems && data.order.nonReturnableItems.length > 0) {
        showError('returnEntryError', T.all_expired_message);
        return;
      }

      /* Map quantity to maxReturnableQuantity for UI compatibility */
      if (state.orderData.returnableItems) {
        state.orderData.returnableItems.forEach(function(item) {
          if (!item.maxReturnableQuantity) item.maxReturnableQuantity = item.quantity || 1;
        });
      }

      renderItems();
      goTo(1);
    })
    .catch(function(err) {
      btn.classList.remove('return-btn-loading');
      btn.disabled = false;
      console.error('findOrder error:', err);
      showError('returnEntryError', 'Something went wrong. Please try again.');
    });
  }

  /* ---- Render Items ---- */
  function renderItems() {
    var data = state.orderData;
    var list = document.getElementById('returnableItemsList');
    var returnableTitle = document.querySelector('.return-section-title');
    var footer = document.getElementById('returnStep1Footer');
    list.innerHTML = '';

    if (data.returnableItems && data.returnableItems.length > 0) {
      returnableTitle.style.display = 'flex';
      /* Set-component rows (parentLineItemId) render grouped inside one set
         card, at the position of their first member; everything else keeps
         the flat per-item card. */
      var renderedSets = {};
      data.returnableItems.forEach(function(item, i) {
        if (item.parentLineItemId) {
          if (renderedSets[item.parentLineItemId]) return;
          renderedSets[item.parentLineItemId] = true;
          list.innerHTML += buildSetCard(i);
        } else {
          list.innerHTML += buildProductCard(item, i, false);
        }
      });
      updateSetSummaries();
    } else {
      returnableTitle.style.display = 'none';
    }

    var nrList = document.getElementById('nonReturnableItemsList');
    var nrTitle = document.getElementById('nonReturnableTitle');
    nrList.innerHTML = '';

    if (data.nonReturnableItems && data.nonReturnableItems.length > 0) {
      nrTitle.style.display = 'flex';
      data.nonReturnableItems.forEach(function(item) {
        nrList.innerHTML += buildProductCard(item, -1, true);
      });
    } else {
      nrTitle.style.display = 'none';
    }

    /* allExpired: hide entire footer, user goes back via top-left arrow */
    if (data.allExpired) {
      footer.style.display = 'none';
    } else {
      footer.style.display = 'flex';
      footer.innerHTML = '<button class="return-btn-secondary" onclick="returnApp.goTo(0)">' + T.back + '</button>' +
        '<button class="return-btn-primary return-btn-next" onclick="returnApp.goTo(2)">' + T.continue_btn + '</button>';
    }

    /* Re-attach already-uploaded image previews (e.g. after coming back from Step 2). */
    Object.keys(state.uploadedImages).forEach(function(idx) {
      var previews = document.getElementById('returnPreviews' + idx);
      if (!previews) return;
      (state.uploadedImages[idx] || []).forEach(function(img, imgIdx) {
        if (!img) return;
        var div = document.createElement('div');
        div.className = 'return-upload-preview';
        div.setAttribute('data-img-idx', imgIdx);
        if (img.contentType && img.contentType.startsWith('video/')) {
          div.innerHTML = '<video src="data:' + img.contentType + ';base64,' + img.base64 + '" style="width:100%;height:100%;object-fit:cover;"></video>' +
            '<button class="return-remove-btn" onclick="event.stopPropagation();returnApp.removeImage(' + idx + ',' + imgIdx + ',this.parentElement)">x</button>';
        } else {
          div.innerHTML = '<img src="data:' + img.contentType + ';base64,' + img.base64 + '">' +
            '<button class="return-remove-btn" onclick="event.stopPropagation();returnApp.removeImage(' + idx + ',' + imgIdx + ',this.parentElement)">x</button>';
        }
        previews.appendChild(div);
      });
    });
  }

  function buildProductCard(item, idx, isNR, asSetChild) {
    var sel = state.selectedItems[idx];
    var isSelected = !isNR && !!sel;
    var cls = isNR ? 'return-product-card non-returnable' : 'return-product-card';
    if (asSetChild) cls += ' return-product-card--set-child';
    if (isSelected) cls += ' selected';
    var checkStyle = isNR ? ' style="border-color:#e5e5e5"' : '';
    var imgSrc = thumbUrl(item.imageUrl);

    var html = '<div class="' + cls + '" data-idx="' + idx + '">';
    var rowClick = isNR ? '' : ' onclick="returnApp.toggleItem(this.parentNode, ' + idx + ')"';
    html += '<div class="return-product-row"' + rowClick + '>';
    html += '<div class="return-product-checkbox"' + checkStyle + '><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg></div>';
    if (imgSrc) {
      html += '<div class="return-product-img"><img src="' + imgSrc + '" alt=""></div>';
    }
    var vd = parseVariantDisplay(item.variantTitle);
    html += '<div class="return-product-info"><div class="return-product-name">' + item.title + '</div>';
    if (vd.textParts) html += '<div class="return-product-variant">' + vd.textParts + '</div>';
    if (vd.swatchHtml) html += '<div class="return-product-variant">' + vd.swatchHtml + '</div>';
    if (!asSetChild) html += setHintHtml(item); /* inside a set card the parent header already says it */
    if (isNR) html += '<div class="return-nr-reason">' + (NR_REASON_LABELS[item.reason] || item.reason) + '</div>';
    html += '</div>';
    html += '<div class="return-product-price">' + renderMoney(item) + '</div>';
    html += '</div>';

    /* Returnable: render the per-item details block (quantity + reason + description + upload).
       CSS shows it only when the card is in `.selected` state. */
    if (!isNR) {
      var initialSel = sel || { quantity: 1, reason: '', description: '' };
      var max = item.maxReturnableQuantity || 1;

      html += '<div class="return-details">';

      /* Return quantity */
      html += '<div class="return-qty-row"><span class="return-qty-label">' + T.return_quantity + '</span>';
      html += '<div class="return-qty-ctrl"><button type="button" onclick="returnApp.changeQty(' + idx + ',-1)">&#8722;</button>';
      html += '<input type="text" value="' + (initialSel.quantity || 1) + '" readonly id="returnQty' + idx + '">';
      html += '<button type="button" onclick="returnApp.changeQty(' + idx + ',1)" data-max="' + max + '">+</button></div></div>';

      /* Return reason icon grid. Normally all 5 reasons; EU-unfulfilled shows only "Others". */
      var reasonOptions = isEUUnfulfilled()
        ? REASON_OPTIONS.filter(function(o) { return o.value === 'OTHERS'; })
        : REASON_OPTIONS;
      var reasonRequired = !isEUReasonOptional();
      html += '<div class="return-reason-group" id="returnReasonGroup' + idx + '"><label>' + T.return_reason + ' <span class="return-req' + (reasonRequired ? ' is-required' : '') + '">' + (reasonRequired ? T.required : T.optional) + '</span></label>';
      html += '<div class="return-reason-grid" id="returnReasonGrid' + idx + '">';
      reasonOptions.forEach(function(o) {
        if (!o.value) return;
        var iconUrl = REASON_ICONS[o.value] || '';
        var selectedCls = (initialSel.reason === o.value) ? ' selected' : '';
        html += '<button type="button" class="return-reason-option' + selectedCls + '" data-reason="' + o.value + '" data-idx="' + idx + '" onclick="returnApp.selectReason(this,' + idx + ',\'' + o.value + '\')">';
        html += '<span class="return-reason-option-icon">';
        if (iconUrl) html += '<img src="' + iconUrl + '" alt="">';
        html += '</span>';
        html += '<span class="return-reason-option-label">' + o.label + '</span>';
        html += '</button>';
      });
      html += '</div>';
      html += '<input type="hidden" id="returnReason' + idx + '" value="' + (initialSel.reason || '') + '">';
      html += '<div class="return-reason-hint-text">' + T.reason_hint + '</div>';
      html += '</div>';

      /* Description (visible once reason chosen) */
      var showDesc = initialSel.reason ? 'block' : 'none';
      var descRequired = descriptionRequiredFor(initialSel.reason);
      html += '<div class="return-reason-group" id="returnDescGroup' + idx + '" style="display:' + showDesc + '"><label>' + T.return_description + ' <span class="return-req' + (descRequired ? ' is-required' : '') + '" id="returnDescReq' + idx + '">' + (descRequired ? T.required : T.optional) + '</span></label>';
      html += '<textarea placeholder="' + T.description_placeholder + '" maxlength="500" oninput="returnApp.updateDescCounter(' + idx + ')" id="returnDesc' + idx + '">' + (initialSel.description || '') + '</textarea>';
      html += '<div class="return-desc-counter" id="returnDescCounter' + idx + '">' + ((initialSel.description || '').length) + '/500</div></div>';

      /* Upload proof (visible once reason chosen) */
      var showUpload = initialSel.reason ? 'block' : 'none';
      var proofRequired = proofRequiredFor(initialSel.reason);
      html += '<div class="return-upload-area" id="returnUploadArea' + idx + '" style="display:' + showUpload + '">';
      html += '<label>' + T.upload_proof + ' <span class="return-req' + (proofRequired ? ' is-required' : '') + '" id="returnProofReq' + idx + '">' + (proofRequired ? T.required : T.optional) + '</span></label>';
      html += '<div class="return-upload-zone" onclick="returnApp.triggerUpload(' + idx + ')">';
      html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 16V4m0 0L8 8m4-4l4 4"/><path d="M2 17l.621 2.485A2 2 0 004.561 21h14.878a2 2 0 001.94-1.515L22 17"/></svg>';
      html += '<p>' + T.click_to_upload + '</p><p class="return-upload-hint">' + T.upload_hint + '</p><p class="return-upload-hint">10MB</p></div>';
      html += '<div class="return-upload-previews" id="returnPreviews' + idx + '"></div>';
      html += '<input type="file" accept="image/*,video/*" multiple style="display:none" id="returnFileInput' + idx + '" onchange="returnApp.handleFiles(this,' + idx + ')">';
      html += '</div>';

      html += '</div>'; /* end return-details */
    }

    html += '</div>';
    return html;
  }

  /* ---- Set (bundle) group card: parent header + nested component rows ---- */

  /* Indices of all component rows belonging to one set line. */
  function setGroupIndices(parentLineItemId) {
    var out = [];
    (state.orderData.returnableItems || []).forEach(function(item, i) {
      if (item.parentLineItemId === parentLineItemId) out.push(i);
    });
    return out;
  }

  /* Pseudo-item whose price fields are the whole set's purchased amount
     (Σ component unit price × quantity), so renderMoney formats it like any
     item — components were allocated from the set price, so this sums back
     to what the customer paid for the set. */
  function setTotalsItem(idxs) {
    var t = { price: 0, presentmentPrice: 0, paidPrice: 0, paidPresentmentPrice: 0 };
    idxs.forEach(function(i) {
      var it = state.orderData.returnableItems[i];
      var q = it.quantity || 1;
      t.price += parseFloat(it.price || 0) * q;
      t.presentmentPrice += parseFloat(it.presentmentPrice || it.price || 0) * q;
      t.paidPrice += parseFloat(it.paidPrice || it.price || 0) * q;
      t.paidPresentmentPrice += parseFloat(it.paidPresentmentPrice || it.presentmentPrice || it.price || 0) * q;
    });
    var first = state.orderData.returnableItems[idxs[0]];
    return {
      price: String(t.price), presentmentPrice: String(t.presentmentPrice),
      paidPrice: String(t.paidPrice), paidPresentmentPrice: String(t.paidPresentmentPrice),
      currencyCode: first.currencyCode, presentmentCurrencyCode: first.presentmentCurrencyCode,
    };
  }

  /* One card per set: header (checkbox + title + "returning X of N pieces" +
     set total) → nested component rows (full per-item flow: qty/reason/
     description/upload) → "Estimated refund for this set" footer. */
  function buildSetCard(firstIdx) {
    var data = state.orderData;
    var parentId = data.returnableItems[firstIdx].parentLineItemId;
    var idxs = setGroupIndices(parentId);
    var first = data.returnableItems[firstIdx];

    var html = '<div class="return-set-card" data-set-first="' + firstIdx + '">';
    html += '<div class="return-set-head" id="returnSetHead' + firstIdx + '" onclick="returnApp.toggleSet(' + firstIdx + ')">';
    html += '<div class="return-product-checkbox"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg></div>';
    html += '<div class="return-set-head-info">';
    html += '<div class="return-set-title">' + escapeHtml(first.setTitle || '') + '</div>';
    html += '<div class="return-set-pieces" id="returnSetPieces' + firstIdx + '"></div>';
    html += '</div>';
    html += '<div class="return-product-price">' + renderMoney(setTotalsItem(idxs)) + '</div>';
    html += '</div>';
    html += '<div class="return-set-children">';
    idxs.forEach(function(i) {
      html += buildProductCard(data.returnableItems[i], i, false, true);
    });
    html += '</div>';
    html += '<div class="return-set-foot"><span>' + T.set_estimated_refund + '</span><span id="returnSetRefund' + firstIdx + '"></span></div>';
    html += '</div>';
    html += '<div class="return-set-note">' + T.set_price_note + '</div>';
    return html;
  }

  /* Refresh every set card's header state, "X of N pieces" line and
     estimated-refund footer from the current selection. */
  function updateSetSummaries() {
    var data = state.orderData;
    if (!data) return;
    var cards = document.querySelectorAll('.return-set-card');
    for (var c = 0; c < cards.length; c++) {
      var firstIdx = parseInt(cards[c].getAttribute('data-set-first'), 10);
      var parentId = data.returnableItems[firstIdx].parentLineItemId;
      var idxs = setGroupIndices(parentId);
      var totalPieces = 0, selectedPieces = 0, refund = 0, currency = 'USD';
      idxs.forEach(function(i) {
        var it = data.returnableItems[i];
        totalPieces += it.quantity || 1;
        currency = it.presentmentCurrencyCode || it.currencyCode || 'USD';
        var sel = state.selectedItems[i];
        if (sel) {
          selectedPieces += sel.quantity || 1;
          refund += parseFloat(it.paidPresentmentPrice || it.presentmentPrice || it.price || 0) * (sel.quantity || 1);
        }
      });
      var head = document.getElementById('returnSetHead' + firstIdx);
      if (head) head.classList.toggle('selected', selectedPieces > 0);
      var pieces = document.getElementById('returnSetPieces' + firstIdx);
      if (pieces) {
        pieces.textContent = selectedPieces > 0
          ? T.set_pieces_summary.replace(/\{\{\s*count\s*\}\}/g, selectedPieces).replace(/\{\{\s*total\s*\}\}/g, totalPieces)
          : T.set_pieces_total.replace(/\{\{\s*total\s*\}\}/g, totalPieces);
      }
      var refundEl = document.getElementById('returnSetRefund' + firstIdx);
      if (refundEl) refundEl.textContent = formatPresentmentAmount(refund, currency);
    }
  }

  /* Parent checkbox: any component unselected → select all; else deselect all. */
  function toggleSet(firstIdx) {
    var parentId = state.orderData.returnableItems[firstIdx].parentLineItemId;
    var idxs = setGroupIndices(parentId);
    var allSelected = idxs.every(function(i) { return !!state.selectedItems[i]; });
    idxs.forEach(function(i) {
      var card = document.querySelector('.return-product-card[data-idx="' + i + '"]');
      if (!card) return;
      var isSelected = !!state.selectedItems[i];
      if (allSelected === isSelected) toggleItem(card, i);
    });
  }

  /* ---- Toggle Item ---- */
  function toggleItem(card, idx) {
    card.classList.toggle('selected');
    if (card.classList.contains('selected')) {
      state.selectedItems[idx] = { quantity: 1, reason: '', description: '' };
      if (!state.uploadedImages[idx]) state.uploadedImages[idx] = [];
    } else {
      delete state.selectedItems[idx];
      delete state.uploadedImages[idx];
    }
    updateSetSummaries();
  }

  /* ---- Quantity ---- */
  function changeQty(idx, delta) {
    var input = document.getElementById('returnQty' + idx);
    var val = parseInt(input.value) || 1;
    var max = parseInt(state.orderData.returnableItems[idx].maxReturnableQuantity) || 1;
    val = Math.max(1, Math.min(max, val + delta));
    input.value = val;
    if (state.selectedItems[idx]) state.selectedItems[idx].quantity = val;
    updateSetSummaries();
  }

  /* ---- Reason change (Step 2) ---- */
  function selectReason(btn, idx, reason) {
    /* Toggle selected state on sibling buttons */
    var grid = document.getElementById('returnReasonGrid' + idx);
    if (grid) {
      var opts = grid.querySelectorAll('.return-reason-option');
      for (var i = 0; i < opts.length; i++) opts[i].classList.remove('selected');
    }
    if (btn) btn.classList.add('selected');

    var hidden = document.getElementById('returnReason' + idx);
    if (hidden) hidden.value = reason;

    onReasonChange({ value: reason }, idx);
  }

  function onReasonChange(select, idx) {
    var reason = select.value;
    var descGroup = document.getElementById('returnDescGroup' + idx);
    var uploadArea = document.getElementById('returnUploadArea' + idx);
    var descReq = document.getElementById('returnDescReq' + idx);
    var proofReq = document.getElementById('returnProofReq' + idx);

    if (descGroup) descGroup.style.display = reason ? 'block' : 'none';
    if (uploadArea) uploadArea.style.display = reason ? 'block' : 'none';

    var descRequired = descriptionRequiredFor(reason);
    var proofRequired = proofRequiredFor(reason);
    if (descReq) { descReq.textContent = descRequired ? T.required : T.optional; descReq.className = descRequired ? 'return-req is-required' : 'return-req'; }
    if (proofReq) { proofReq.textContent = proofRequired ? T.required : T.optional; proofReq.className = proofRequired ? 'return-req is-required' : 'return-req'; }

    if (state.selectedItems[idx]) state.selectedItems[idx].reason = reason;
  }

  /* ---- Upload (with Canvas compression) ---- */
  function triggerUpload(idx) {
    var existing = (state.uploadedImages[idx] || []).filter(function(x) { return x !== null; }).length;
    if (existing >= MAX_IMAGES_PER_ITEM) {
      alert(T.upload_limit_exceeded);
      return;
    }
    document.getElementById('returnFileInput' + idx).click();
  }

  function handleFiles(input, idx) {
    var files = input.files;
    if (!files || !files.length) return;
    if (!state.uploadedImages[idx]) state.uploadedImages[idx] = [];

    var existing = (state.uploadedImages[idx]).filter(function(x) { return x !== null; }).length;
    var remaining = MAX_IMAGES_PER_ITEM - existing;
    if (files.length > remaining) {
      alert(T.upload_limit_exceeded);
      input.value = '';
      return;
    }

    var previews = document.getElementById('returnPreviews' + idx);

    for (var i = 0; i < files.length; i++) {
      (function(file) {
        var isVideo = file.type && file.type.startsWith('video/');
        var maxSize = 10 * 1024 * 1024;
        var maxLabel = '10MB';
        if (file.size > maxSize) {
          alert('File too large: ' + (file.size / 1024 / 1024).toFixed(1) + 'MB (max ' + maxLabel + ')');
          return;
        }

        function addPreview(result) {
          var imgIdx = state.uploadedImages[idx].length;
          state.uploadedImages[idx].push(result);

          var div = document.createElement('div');
          div.className = 'return-upload-preview';
          div.setAttribute('data-img-idx', imgIdx);
          if (isVideo) {
            div.innerHTML = '<video src="data:' + result.contentType + ';base64,' + result.base64 + '" style="width:100%;height:100%;object-fit:cover;"></video>' +
              '<button class="return-remove-btn" onclick="event.stopPropagation();returnApp.removeImage(' + idx + ',' + imgIdx + ',this.parentElement)">x</button>';
          } else {
            div.innerHTML = '<img src="data:' + result.contentType + ';base64,' + result.base64 + '">' +
              '<button class="return-remove-btn" onclick="event.stopPropagation();returnApp.removeImage(' + idx + ',' + imgIdx + ',this.parentElement)">x</button>';
          }
          previews.appendChild(div);

          var validCount = state.uploadedImages[idx].filter(function(x) { return x !== null; }).length;
          if (validCount >= MAX_IMAGES_PER_ITEM) {
            var zone = document.querySelector('#returnUploadArea' + idx + ' .return-upload-zone');
            if (zone) zone.style.display = 'none';
          }
        }

        if (isVideo) {
          /* Videos: read as base64 directly (no compression) */
          var reader = new FileReader();
          reader.onload = function(e) {
            var dataUrl = e.target.result;
            var base64 = dataUrl.split(',')[1];
            addPreview({ base64: base64, contentType: file.type, fileName: file.name });
          };
          reader.onerror = function() { alert('Failed to read video: ' + file.name); };
          reader.readAsDataURL(file);
        } else {
          /* Images: compress via canvas */
          compressImage(file).then(function(result) {
            addPreview(result);
          }).catch(function(err) {
            console.error('Image compression failed:', err);
            alert(err.message || 'Failed to process image: ' + file.name);
          });
        }
      })(files[i]);
    }
    input.value = '';
  }

  function updateDescCounter(idx) {
    var desc = document.getElementById('returnDesc' + idx);
    var counter = document.getElementById('returnDescCounter' + idx);
    if (desc && counter) counter.textContent = desc.value.length + '/500';
  }

  function removeImage(idx, imgIdx, element) {
    if (state.uploadedImages[idx]) {
      state.uploadedImages[idx][imgIdx] = null; /* Mark as removed */
    }
    if (element) element.remove();
    /* Re-show upload zone after removal */
    var zone = document.querySelector('#returnUploadArea' + idx + ' .return-upload-zone');
    if (zone) zone.style.display = '';
  }

  /* ---- Render a what-to-expect paragraph block ----
   * Splits on \n\n into paragraphs and turns each \n into <br>, so locale copy
   * can use multi-line bullet structure without raw HTML.
   */
  function renderExpectParagraphs(text) {
    return text.split(/\n\s*\n/).map(function(p) {
      return '<div class="return-expect-paragraph">' + p.replace(/\n/g, '<br>') + '</div>';
    }).join('');
  }

  /* ---- Build Review ----
   * Single order-level solution per submission. Two code paths:
   *   - US shipping: keeps legacy what-to-expect (with $6.89 shipping fee text)
   *   - non-US shipping: new bullet-style what-to-expect with bonus gift card copy
   */
  function buildReview() {
    var data = state.orderData;
    var countryCode = state.orderData && state.orderData.shippingCountryCode;
    var isUS = countryCode === 'US';
    var orderSolution = state.orderSolution;
    var html = '';

    /* Return items — product info only (no reason/solution, those go in details card) */
    html += '<div class="return-review-section"><h3>' + T.return_items + '</h3>';
    var selectedKeys = Object.keys(state.selectedItems);
    selectedKeys.forEach(function(idx) {
      var item = data.returnableItems[idx];
      var sel = state.selectedItems[idx];
      var imgSrc = thumbUrl(item.imageUrl);
      var vd3 = parseVariantDisplay(item.variantTitle);

      html += '<div class="return-review-item-card">';
      html += '<div class="return-review-item">';
      if (imgSrc) html += '<div class="return-review-item-img"><img src="' + imgSrc + '"></div>';
      html += '<div class="return-review-item-info">';
      html += '<div class="return-review-item-name">' + item.title + '</div>';
      if (vd3.textParts) html += '<div class="return-review-item-detail">' + vd3.textParts + '</div>';
      if (vd3.swatchHtml) html += '<div class="return-review-item-detail">' + vd3.swatchHtml + '</div>';
      html += setHintHtml(item);
      html += '<div class="return-review-item-detail">Return quantity: ' + sel.quantity + '</div>';
      html += '</div>';
      html += '<div class="return-product-price">' + renderMoney(item) + '</div>';
      html += '</div>';
      html += '</div>';
    });
    html += '</div>';

    var methodLabel = isUS ? T.review_method_prepaid_label : T.review_method_ship_self;

    /* Reason text: same logic as before — merge if all items share the same reason, otherwise per-item rows */
    var itemDetails = selectedKeys.map(function(idx) {
      var item = data.returnableItems[idx];
      var sel = state.selectedItems[idx];
      var rl = sel.reason ? REASON_OPTIONS.find(function(o) { return o.value === sel.reason; }) : null;
      return {
        title: item.title,
        reason: rl ? rl.label : '-',
        exchangeInfo: orderSolution === 'EXCHANGE' ? [sel.exchangeProductTitle, sel.exchangeVariantTitle].filter(Boolean).join(' — ') : '',
      };
    });
    var allSameReason = itemDetails.every(function(d) { return d.reason === itemDetails[0].reason; });
    var reasonHtml = allSameReason
      ? itemDetails[0].reason
      : itemDetails.map(function(d) { return d.title + ': ' + d.reason; }).join('<br>');

    /* Solution text: order-level label + per-item exchange info when EXCHANGE */
    var solutionHtml = orderSolution ? getSolutionLabel(orderSolution) : '-';
    if (orderSolution === 'EXCHANGE') {
      itemDetails.forEach(function(d) {
        if (d.exchangeInfo) {
          solutionHtml += '<br>' + (selectedKeys.length > 1 ? d.title + ' — ' : '') + T.review_exchange_info + ': ' + d.exchangeInfo;
        }
      });
    }

    /* What-to-expect */
    var reviewEmail =
      (document.getElementById('returnCustomerEmail') || {}).value ||
      (document.getElementById('returnEmail') || {}).value || '';

    /* Paid total of all selected items in presentment currency, with currency symbol — used by the legacy US copy.
       Refunds match what the customer actually paid, so this uses paid (after-all-discounts) prices. */
    function formatOrderTotal() {
      var total = selectedKeys.reduce(function(sum, idx) {
        var item = data.returnableItems[idx];
        var sel = state.selectedItems[idx];
        return sum + parseFloat(item.paidPresentmentPrice || item.presentmentPrice || item.price || 0) * (sel.quantity || 1);
      }, 0);
      var firstItem = data.returnableItems[selectedKeys[0]];
      var currency = firstItem.presentmentCurrencyCode || firstItem.currencyCode || 'USD';
      return formatPresentmentAmount(total, currency);
    }

    /**
     * Order totals for the non-US store-credit copy, using paid
     * (after-all-discounts) prices so the promise matches the refund:
     *   - usd: the gift-card value in shop currency (USD), code-formatted "USD 55.20"
     *   - presentment: the amount the customer actually paid, code-formatted "SAR 207.00"
     */
    function computeReturnTotals() {
      var usdTotal = 0;
      var presentmentTotal = 0;
      selectedKeys.forEach(function(idx) {
        var item = data.returnableItems[idx];
        var sel = state.selectedItems[idx];
        var qty = sel.quantity || 1;
        usdTotal += parseFloat(item.paidPrice || item.price || 0) * qty;
        presentmentTotal += parseFloat(item.paidPresentmentPrice || item.presentmentPrice || item.price || 0) * qty;
      });
      var first = data.returnableItems[selectedKeys[0]];
      var usdCurrency = first.currencyCode || 'USD';
      var presentmentCurrency = first.presentmentCurrencyCode || first.currencyCode || 'USD';
      return {
        usd: formatMoneyCode(usdTotal, usdCurrency),
        presentment: formatMoneyCode(presentmentTotal, presentmentCurrency),
        sameCurrency: presentmentCurrency === usdCurrency,
      };
    }

    /* ---- What-to-expect copy ----
     * Keyed on region × solution. A Damaged/defect reason overrides everything
     * with a single "we'll review your photos" message (same for US and non-US).
     * EXCHANGE and REPLACE share one copy. The trailing "If we need…" line is
     * baked into each locale string, so no separate follow-up is appended. */
    var emailLink = '<a href="mailto:' + escapeHtml(reviewEmail) + '">' + escapeHtml(reviewEmail) + '</a>';
    var expectTemplate;
    if (isEUUnfulfilled()) {
      /* EU + unfulfilled (always non-US). Exchange uses its own wording
         ("your request" vs "your return request"); store-credit / refund share
         the default copy. No amount/bonus placeholders in either. */
      expectTemplate = (orderSolution === 'EXCHANGE')
        ? T.review_expect_eu_unfulfilled_exchange
        : T.review_expect_eu_unfulfilled;
    } else if (allSelectedDefective()) {
      expectTemplate = T.review_expect_defect;
    } else if (isUS) {
      expectTemplate =
          orderSolution === 'REFUND_STORE_CREDIT' ? T.review_expect_credit
        : orderSolution === 'REFUND_ORIGINAL'     ? T.review_expect_refund_us
        : /* EXCHANGE / REPLACE */                  T.review_expect_exchange;
    } else {
      /* Non-US store-credit/exchange normally promise the $10 bonus; when it's
         withheld (repeat return within 7 days) use the no-bonus variants. */
      var bonusOk = !(state.orderData && state.orderData.bonusSuppressed);
      expectTemplate =
          orderSolution === 'REFUND_STORE_CREDIT' ? (bonusOk ? T.review_expect_credit_v2 : T.review_expect_credit_v2_nobonus)
        : orderSolution === 'REFUND_ORIGINAL'     ? T.review_expect_refund_v2
        : /* EXCHANGE / REPLACE */                  (bonusOk ? T.review_expect_exchange_v2 : T.review_expect_exchange_v2_nobonus);
    }

    var filled = expectTemplate || '';
    if (isEUUnfulfilled()) {
      /* Only {{ email }} to fill — handled below; no amount/bonus placeholders. */
    } else if (isUS) {
      /* US store-credit shows the gift-card value in the customer's currency */
      filled = filled.replace(/\{\{\s*amount\s*\}\}/g, formatOrderTotal());
    } else {
      var totals = computeReturnTotals();
      /* Customer checked out in USD — drop the redundant "(≈ {{ amount }})" parenthetical */
      if (totals.sameCurrency) {
        filled = filled.replace(/\s*\(≈\s*\{\{\s*amount\s*\}\}\)/g, '');
      }
      filled = filled
        .replace(/\{\{\s*usd_amount\s*\}\}/g, totals.usd)
        .replace(/\{\{\s*amount\s*\}\}/g, totals.presentment)
        /* translated locales may still carry {{ bonus }} until the translation app re-syncs */
        .replace(/\{\{\s*bonus\s*\}\}/g, '10');
    }
    filled = filled.replace(/\{\{\s*email\s*\}\}/g, emailLink);
    filled = linkifyStoreDomain(filled);
    var expectText = renderExpectParagraphs(filled);

    html += '<div class="return-review-section"><h3>' + T.review_return_details + '</h3>';
    html += '<div class="return-review-details-card">';
    html += '<div class="return-review-detail-row"><span class="return-review-detail-label">' + T.review_return_order + '</span><span>' + data.name + '</span></div>';
    html += '<div class="return-review-detail-row"><span class="return-review-detail-label">' + T.review_return_reason + '</span><span>' + reasonHtml + '</span></div>';
    html += '<div class="return-review-detail-row"><span class="return-review-detail-label">' + T.review_return_solution + '</span><span>' + solutionHtml + '</span></div>';
    /* Return method: US ships with a prepaid label, non-US ships on their own
       (methodLabel resolves per region above). Defect returns are routed through
       a CS photo review, and EU-unfulfilled returns get instructions by email
       later — in both cases the method isn't decided yet, so hide the row. */
    if (!allSelectedDefective() && !isEUUnfulfilled()) {
      html += '<div class="return-review-detail-row"><span class="return-review-detail-label">' + T.review_return_method + '</span><span>' + methodLabel + '</span></div>';
    }
    html += '<div class="return-review-detail-row"><span class="return-review-detail-label">' + T.review_what_to_expect + '</span><span class="return-review-expect-text">' + expectText + '</span></div>';
    html += '</div></div>';

    document.getElementById('returnReviewContent').innerHTML = html;

    /* Submit button label reflects the chosen solution: exchange/replace vs return. */
    var submitBtn = document.getElementById('returnSubmitBtn');
    if (submitBtn) {
      var isExchangeKind = orderSolution === 'EXCHANGE' || orderSolution === 'REPLACE';
      submitBtn.textContent = isExchangeKind ? T.confirmed_exchange : T.confirmed_return;
    }
  }

  /* ---- Back-from-review: jumps to Step 2.5 for multi-item exchange, otherwise Step 2 ---- */
  function backFromReview() {
    var selectedCount = Object.keys(state.selectedItems).length;
    if (state.orderSolution === 'EXCHANGE' && selectedCount > 1) {
      goTo('2_5');
    } else {
      goTo(2);
    }
  }

  /* ---- Submit (real API: upload images then submit) ---- */
  async function submit() {
    var btn = document.getElementById('returnSubmitBtn');
    btn.classList.add('return-btn-loading');
    btn.disabled = true;

    try {
      var data = state.orderData;
      var returnLineItems = [];

      /* Build returnLineItems with uploaded image URLs */
      var selectedKeys = Object.keys(state.selectedItems);
      for (var k = 0; k < selectedKeys.length; k++) {
        var idx = selectedKeys[k];
        var item = data.returnableItems[idx];
        var sel = state.selectedItems[idx];

        /* Sync from DOM */
        var reasonSelect = document.getElementById('returnReason' + idx);
        if (reasonSelect) sel.reason = reasonSelect.value;
        var descInput = document.getElementById('returnDesc' + idx);
        if (descInput) sel.description = descInput.value;

        /* Upload images (if any) */
        var imageUrls = [];
        var feishuImageKeys = [];
        var images = (state.uploadedImages[idx] || []).filter(function(x) { return x !== null; });
        for (var i = 0; i < images.length; i++) {
          var img = images[i];
          var uploadResp = await fetch(API_BASE + '/upload_return_image', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              customerId: state.orderData.customerId,
              fileName: img.fileName,
              contentType: img.contentType,
              base64Data: img.base64,
            }),
          });
          var uploadData = await uploadResp.json();
          if (!uploadData.success) {
            throw new Error('Image upload failed: ' + (uploadData.error || 'Unknown error'));
          }
          imageUrls.push(uploadData.imageUrl);
          if (uploadData.feishuImageKey) {
            feishuImageKeys.push(uploadData.feishuImageKey);
          }
        }

        var lineItem = {
          lineItemId: item.lineItemId,
          title: item.title,
          quantity: sel.quantity,
          /* Order-level solution copied onto every line item — backend schema requires per-item */
          returnSolution: state.orderSolution,
          /* May be empty for EU within-15-days returns (reason optional). */
          returnReason: sel.reason || undefined,
          reasonNote: sel.description || undefined,
          imageUrls: imageUrls.length > 0 ? imageUrls : undefined,
          feishuImageKeys: feishuImageKeys.length > 0 ? feishuImageKeys : undefined,
        };
        if (state.orderSolution === 'EXCHANGE') {
          /* Structured exchange target from <product-picker>. The server re-queries
           * the variant and overwrites title/sku/price with authoritative values;
           * exchangeVariantId is the only field it trusts. */
          lineItem.exchangeVariantId = sel.exchangeVariantId || undefined;
          lineItem.exchangeProductId = sel.exchangeProductId || undefined;
          lineItem.exchangeProductTitle = sel.exchangeProductTitle || undefined;
          lineItem.exchangeVariantTitle = sel.exchangeVariantTitle || undefined;
          lineItem.exchangeSku = sel.exchangeSku || undefined;
          lineItem.exchangePrice = sel.exchangePrice || undefined;
        }
        returnLineItems.push(lineItem);
      }

      /* Submit return request */
      var email = '';
      var emailEl = document.getElementById('returnCustomerEmail');
      if (emailEl) {
        email = emailEl.value;
      } else {
        email = (document.getElementById('returnEmail') || {}).value || '';
      }

      var submitResp = await fetch(API_BASE + '/submit_return', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          orderId: data.id,
          orderName: data.name,
          email: email,
          shippingCountryCode: data.shippingCountryCode || '',
          supportsSetComponents: true,
          returnLineItems: returnLineItems,
        }),
      });
      var submitData = await submitResp.json();

      if (!submitData.success) {
        throw new Error(submitData.error || 'Submit failed');
      }

      btn.classList.remove('return-btn-loading');
      btn.disabled = false;

      /* Render success page — 0330: simplified, only title + one line message + button */
      resetSuccessPage();
      var countryCode = state.orderData && state.orderData.shippingCountryCode;
      var isUS = countryCode === 'US';
      var isRefundSolution = state.orderSolution === 'REFUND_STORE_CREDIT' || state.orderSolution === 'REFUND_ORIGINAL';

      document.getElementById('returnSuccessMessage').textContent =
        isUS
          ? (isRefundSolution && allSelectedDefective() ? T.success_us_intro_defective : T.success_us_intro)
          : T.success_nonus_intro;

      goTo(4);
    } catch (err) {
      btn.classList.remove('return-btn-loading');
      btn.disabled = false;
      console.error('Submit error:', err);
      showError('returnSubmitError', err.message || 'Something went wrong. Please try again.');
    }
  }

  /* ---- Wire the <product-picker> component into per-item exchange state ----
   * The component bubbles these events up to document; we route them by
   * contextIdx (the item index) into state.selectedItems. */
  document.addEventListener('enroute:product-picked', function(e) {
    var d = e.detail || {};
    var sel = state.selectedItems[d.contextIdx];
    if (!sel) return;
    sel.exchangeVariantId = d.variantId;
    sel.exchangeProductId = d.productId;
    sel.exchangeProductTitle = d.title;
    sel.exchangeVariantTitle = d.variantTitle;
    sel.exchangeSku = d.sku;
    sel.exchangePrice = d.price;
    updateExchangePickedLabel(d.contextIdx);
  });
  document.addEventListener('enroute:product-enrolled', function(e) {
    var d = e.detail || {};
    var sel = state.selectedItems[d.contextIdx];
    if (!sel) return;
    /* Out-of-stock target: the customer registered for a back-in-stock notice.
     * Recorded as intent only — it is not a valid exchange pick (an in-stock
     * variant is still required to pass Step-3 validation). */
    sel.exchangeEnrolledVariantId = d.variantId;
  });

  /* ---- Expose to global ---- */
  window.returnApp = {
    goTo: goTo,
    nextFromStep2: nextFromStep2,
    backFromReview: backFromReview,
    findOrder: findOrder,
    toggleItem: toggleItem,
    toggleSet: toggleSet,
    changeQty: changeQty,
    onOrderSolutionChange: onOrderSolutionChange,
    onReasonChange: onReasonChange,
    selectReason: selectReason,
    updateDescCounter: updateDescCounter,
    triggerUpload: triggerUpload,
    handleFiles: handleFiles,
    removeImage: removeImage,
    submit: submit,
  };
})();

  } catch(e) { console.error(e); }
})();
})();
